import "./memeApprovalCss.css";
import BlueButton from "../../../common/BlueButton/BlueButton";
import BlueToggle from "../../../common/BlueToggle";
import { useTranslation } from "react-i18next";
import { useState } from "react";

const ManualApprovalDisplayLogicDashboard = ({
    getSettings,
    currentMeme,
    browserSourceIsActive,
    remotelyApprovedby,
    onButtonClick,
    isApiCallInProgress,
    title,
}) => {
    const { t } = useTranslation("manualApproval");
    const [displayText, setDisplayText] = useState(false);

    let displayComponent = <></>;

    const currentDisplayMemeUrl = currentMeme ? currentMeme.url : "";
    const currentDisplayMemeId = currentMeme ? currentMeme.id : "none";
    const currentDisplayPrice = currentMeme
        ? currentMeme.price
            ? currentMeme.price + " Bits"
            : ""
        : "";
    const currentDisplayTopText = currentMeme
        ? currentMeme.topText
            ? currentMeme.topText
            : ""
        : "";
    const currentDisplayBottomText = currentMeme
        ? currentMeme.bottomText
            ? currentMeme.bottomText
            : ""
        : "";
    const currentDisplayName = currentMeme
        ? currentMeme.displayName
            ? currentMeme.displayName.toUpperCase()
            : ""
        : "";

    const displayTitle = (
        <h2 className="manualApprovalDashboardDisplayTitle">{title}</h2>
    );

    const textdisplayOfMeme = (
        <div className="manualApprovalDashboardDisplayText">
            <p>{currentDisplayPrice} </p>
            <hr className="manualApprovalLineDashboard"></hr>
            <p>{currentDisplayTopText}</p>
            <p>{currentDisplayBottomText}</p>
            <hr className="manualApprovalLineDashboard"></hr>
            <h4>{currentDisplayName}</h4>
        </div>
    );

    const toggleTextDisplay = (
        <div className="manualApprovalDashboardToggleForDisplayText">
            <BlueToggle
                title={t("manualApprovalShowTextToggle")}
                onToggle={() => setDisplayText(!displayText)}
                state={displayText}
            />
        </div>
    );

    const imageDisplayMode = (
        <div className="manualApprovalContainerImageDashboard">
            <img
                className="loadingDisplayMemeApprovalDashboard"
                src={currentDisplayMemeUrl}
                alt={currentDisplayMemeId}
                onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/imageNotFound.jpg";
                }}
            />

            <p className="manualApprovalDisplayNameDashboard">
                {currentDisplayName}
            </p>
        </div>
    );

    const approveDenyButtonDisplay = (
        <>
            <div className="manualApprovalButtonContainerDashboard">
                <BlueButton
                    text="✓"
                    onClick={() => onButtonClick("APPROVE")}
                    isCenter={true}
                />
                <BlueButton
                    text="X"
                    onClick={() => onButtonClick("DENY")}
                    isCenter={true}
                    isDark={true}
                />
            </div>
        </>
    );

    const messageDisplayForNoMeme = (text) => {
        return (
            <>
                <br />
                <div className="manualApprovalContainerDashboard">
                    {displayTitle}
                    <hr className="manualApprovalDashboardDisplayTitleLine"></hr>
                    <div className="manualApprovalContainerNoImageDashboard">
                        <p className="manualApprovalTextDisplayDashboard">
                            {text}
                        </p>
                    </div>
                </div>
            </>
        );
    };
    // Display when meme is present
    displayComponent = (
        <>
            <br />
            <div className="manualApprovalContainerDashboard">
                {displayTitle}
                <hr className="manualApprovalDashboardDisplayTitleLine"></hr>
                <br />
                {toggleTextDisplay}
                {displayText ? textdisplayOfMeme : imageDisplayMode}
                <br />
                <br />
                {approveDenyButtonDisplay}
            </div>
        </>
    );

    // Display when no meme in queue
    if (!currentMeme && browserSourceIsActive)
        displayComponent = messageDisplayForNoMeme(
            t("manualApprovalNoMemesAwaitApproval"),
        );

    // Do not display when toggled off OR when the browser source is not active.
    if (!getSettings().manualApproval || !browserSourceIsActive)
        displayComponent = <></>;

    if (isApiCallInProgress)
        displayComponent = messageDisplayForNoMeme(
            t("manualApprovalProcessingMeme"),
        );

    if (remotelyApprovedby && !isApiCallInProgress) {
        let action = remotelyApprovedby.action
            ? remotelyApprovedby.action.toLowerCase()
            : "confused";
        const actionMessages = {
            approve: t("manualApprovalActionApprove"),
            deny: t("manualApprovalActionDeny"),
            confused: t("manualApprovalActionConfused"),
        };

        action = actionMessages[action] || actionMessages.confused;
        displayComponent = messageDisplayForNoMeme(
            t("manualApprovalMemeApprovalMessage", { action }),
        );
    }

    return displayComponent;
};

export default ManualApprovalDisplayLogicDashboard;
